import { createContext, useContext } from 'react';

import { GetReportAnalyticsEvent, mockedGetReportAnalyticsEvent } from './types';
export interface TelemetryOptions {
  readonly getReportAnalyticsEvent: GetReportAnalyticsEvent;
}

export const defaultOptions: TelemetryOptions = {
  getReportAnalyticsEvent: mockedGetReportAnalyticsEvent,
};

const TelemetryContext = createContext(defaultOptions);
export const TelemetryContextProvider = TelemetryContext.Provider;

export type UseTelemetryOptions = () => TelemetryOptions;
export const useTelemetryOptions: UseTelemetryOptions = () => useContext(TelemetryContext);
